import { z } from "zod/v3";

export const profileSchema = z.object({
  name: z.string().trim().min(1, "Enter your name.").max(80),
  company: z.string().trim().max(120).default(""),
  link: z.string().trim().max(2000).refine(value => {
    if (!value) return true;
    try { const url = new URL(value); return url.protocol === "https:" && !!url.hostname && !url.username && !url.password; }
    catch { return false; }
  }, "Use a full HTTPS link."),
  avatar: z.string().max(100_000).default(""),
});
export type ProfileInput = z.infer<typeof profileSchema>;
export type SignInProvider = { id: "google" | "apple"; name: string; enabled: boolean };
export function initials(name: string) {
  const words = name.trim().split(/\s+/).filter(Boolean);
  return [words[0]?.[0], words.length > 1 ? words.at(-1)?.[0] : ""]
    .join("")
    .toUpperCase() || "?";
}
export const signInErrors: Record<string, string> = {
  signin_failed: "Sign-in could not be completed. Please try again.",
  cancelled: "Sign-in was cancelled. You can try again or use your password.",
  expired: "This sign-in request expired. Please start again.",
  account_exists: "An account already uses this email. Sign in with your existing method, then connect this provider in your profile.",
  already_linked: "This provider account is connected to another profile.",
};
